import React, { useState } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useAuth } from '../context/AuthContext';

/**
 * Renders the customer's own Account ID in monospace with a copy button.
 * Visible only to the 'customer' role — returns null for engineer/super_admin.
 */
export default function AccountIdBadge() {
  const { user } = useAuth();
  const [copied, setCopied] = useState(false);

  if (user?.role !== 'customer' || !user?.customer_id) return null;

  function handleCopy() {
    navigator.clipboard.writeText(user!.customer_id!);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
      <Typography variant="caption" color="text.secondary">
        Account ID — use this when starting a new scan:
      </Typography>
      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25 }}>
        <Typography
          variant="caption"
          sx={{ fontFamily: 'monospace', color: 'text.disabled', fontSize: '0.75rem' }}
        >
          {user.customer_id}
        </Typography>
        <Tooltip title={copied ? 'Copied!' : 'Copy Account ID'} placement="right">
          <IconButton
            size="small"
            onClick={handleCopy}
            sx={{ p: 0.25, opacity: 0.5, '&:hover': { opacity: 1 } }}
          >
            <ContentCopyIcon sx={{ fontSize: 14 }} />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
}
